module.exports = __webpack_public_path__ + "static/media/LogoBambu.24bd892a.svg";